import styled from 'styled-components';
import { mq, getSpace, px2rem, getGridSpans, getGridSpan } from '../../../../stylesheets/tools';

const StyledEducationTabletStage = styled.section`
  padding-top: ${px2rem('20px')};

  ${mq('m')} {
    padding-top: ${px2rem('100px')};
  }

  .tablet-stage {
    display: flex;
    flex-direction: column;
    gap: ${px2rem('10px')};

    ${mq('m')} {
      gap: ${px2rem('0px')};
      flex-direction: row;
    }
    .tablet-stage__number-container {
      width: ${getGridSpan('2', 'spread')};
      margin: 0 auto;

      ${mq('m')} {
        margin: 0;
      }
      .tablet-stage__number {
        ${mq('m')} {
          margin: unset;
          width: ${px2rem('100px')};
          height: ${px2rem('100px')};

          .number__content-container {
            .number__content {
              font-size: ${px2rem('56px')};
            }
          }
        }
      }
    }

    .tablet-stage__content {
      display: flex;
      flex-direction: column;
      ${getGridSpans('width', { s: 12, m: 9 })}

      .tablet-stage__tag {
        margin-right: auto;
        margin-left: auto;
        display: inline-block;

        ${mq('m')} {
          margin-bottom: ${getSpace('xs')};
          margin-left: unset;
        }
        .filter-tag__title {
          padding: 0 ${px2rem('10px')};
          font-size: ${px2rem('16px')};
        }
      }
      .tablet-stage__headline {
        margin-top: ${getSpace('m')};
        margin-bottom: ${getSpace('m')};

        ${mq('m')} {
          margin-top: unset;
        }
      }
    }
  }
`;

export default StyledEducationTabletStage;
